export default {
  paged: {
    select: 'id,isActive,name,approvalStatus,agreementType,ownerType,billingMode',
    searchSelect: ['name'],
    orderBy: 'name asc',
  },
  itemDetail: {},
};
